export default __webpack_public_path__ + "static/media/4849.f984f637.png";